import { format } from "date-fns";
import { tz, TZDate } from "@date-fns/tz";

export function getUkDate(
  input: string | number | Date | null | undefined = new TZDate().withTimeZone(
    "Europe/London"
  )
) {
  return input
    ? new TZDate(
        // @ts-expect-error - TZDate is not typed correctly
        input,
        "Europe/London"
      ).withTimeZone("Europe/London")
    : new TZDate().withTimeZone("Europe/London");
}

export function formatUkDate(
  date: Parameters<typeof format>[0],
  options: Parameters<typeof format>[1]
) {
  return format(date, options, {
    in: tz("Europe/London"),
  });
}

/**
 * The day label the booking summary and the collapsed cart headers both show.
 * One place, so the two never drift apart.
 */
export function formatBookingDay(date: string) {
  return formatUkDate(getUkDate(date), "EEE d MMM yyyy");
}

/**
 * Strict YYYY-MM-DD calendar-date guard. Returns true iff `raw` is a real
 * date in the exact YYYY-MM-DD format (rejects junk AND impossible dates
 * like 2026-13-99 / 2026-02-30 that would otherwise reach `new TZDate(raw)`
 * and throw an unhandled loader 500). Mirrors the inline guard idiom from
 * account+/_authenticated+/bookings.tsx (parseDateParam finite-getTime
 * check).
 *
 * Used by the kiosk route loader's ?date peek param and other date-from-URL
 * call sites that need to fall back to "today" on a malformed input.
 */
export function isValidYmd(raw: string | null | undefined): raw is string {
  if (!raw || !/^\d{4}-\d{2}-\d{2}$/.test(raw)) return false;
  const ms = Date.parse(`${raw}T00:00:00Z`);
  if (Number.isNaN(ms)) return false;
  // Reject month/day rollover (e.g. 2026-02-30 → Mar 2): a real date
  // round-trips back to the identical string.
  return new Date(ms).toISOString().slice(0, 10) === raw;
}
